import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { ContentStateInterface, DropdownOptionSelection, FieldProps } from '../../../../../../../@types/types'
import { BasicInfoScreenValidationResult } from '../../../../../../../@types/validation-types'
import ToggleSwitch, { ToggleSwitchAlignment } from '../../../../../../common/inputs/toggleSwitch/ToggleSwitch'
import { useApplyInsertionDataUpdate } from '../../../../../../logic/useApplyInsertionDataUpdate'
import { DefaultRentPriceTypeOption } from '../../../../../../../@types/dropdown-types'

export type PriceOnRequestToggleAdditionalProps = {
  selectedPriceType: 'REQUEST_RENT_PRICE' | 'REQUEST_PURCHASE_PRICE'
  unselectedPriceType: 'PURCHASE_PRICE' | null
  alignment?: ToggleSwitchAlignment
}
const PriceOnRequestToggle: React.FC<
  FieldProps<BasicInfoScreenValidationResult> & PriceOnRequestToggleAdditionalProps
> = ({ insertionData, selectedPriceType, unselectedPriceType, alignment = 'custom' }) => {
  const { t } = useTranslation()

  const applyInsertionDataUpdate = useApplyInsertionDataUpdate()

  const update = useCallback(
    (value: DropdownOptionSelection) => {
      if (value?.value === DefaultRentPriceTypeOption.REQUEST_RENT_PRICE || value?.value === 'REQUEST_PURCHASE_PRICE') {
        applyInsertionDataUpdate((old): ContentStateInterface => ({
          ...old,
          priceType: value as DropdownOptionSelection,
          price: undefined,
        }))
      } else {
        applyInsertionDataUpdate((old): ContentStateInterface => ({
          ...old,
          priceType: value as DropdownOptionSelection,
        }))
      }
    },
    [applyInsertionDataUpdate]
  )

  return (
    <ToggleSwitch
      id='price-on-request'
      alignment={alignment}
      propertyName='priceType'
      label={t('wizard.screen.basicInfo.priceOnRequest', 'Price on request')}
      value={insertionData.priceType?.value === selectedPriceType}
      onChange={(_, value) => {
        if (value) {
          update({ value: selectedPriceType, label: null })
        } else {
          update({ value: unselectedPriceType, label: null })
        }
      }}
    />
  )
}

export default PriceOnRequestToggle
